import React, { useRef, useState } from "react";
import ErrorMessage from "./ErrorMessage";
import FileUploadErrorModal from "../../utils/fileUploadErrorModal";
import { resolveFileMimeType } from "../../utils/imagePreview";

const FileUpload = (props) => {
    return (
        <React.Fragment>
            <div className="form-field">
                <Input {...props} />
            </div>
        </React.Fragment>
    );
};

export default FileUpload;

const Input = ({
    label,
    children,
    field,
    form,
    className,
    disabled,
    onFileSelected,
    documentName,
    multipleFileUpload,
    ...props
}) => {
    let isDisabled = disabled ? "disabled" : "";
    let disabledClass = disabled ? "cursor-not-allowed" : "";
    let fileUploadRef = useRef();
    const [fileErrorList,setFileErrorList] = useState([]);

    function handleChange() {
        let files = Array.from(fileUploadRef.files)
        const errorList = [];
        files = files.filter((item) => {
            if (item.size === 0) {
                errorList.push({
                    fileName: item?.name,
                    fileSize: item.size
                });
                return false
            } else if (item.size > (500 * 1024 * 1024)) {
                errorList.push({
                    fileName: item?.name,
                    fileSize: item.size,
                    isFileLarge: true
                });
                return false
            }else if(!["jpg","png","jpeg","heic","heif"].includes(resolveFileMimeType(item).split('/')[1])){
                errorList.push({
                    fileName: item?.name,
                    type: item.type
                });
                return false
            }
            return true;
        })
        if(errorList.length){
            setFileErrorList(errorList);
        }
        onFileSelected({ path: fileUploadRef.value, file: files });
    }

    return (
        <React.Fragment>
            {documentName === "medicalRecordsFile" ?
                <label htmlFor="filePicker" className="w-full"> {label}
                    <div>
                        <input
                            type="file"
                            ref={elementRef => fileUploadRef = elementRef}
                            multiple={multipleFileUpload}
                            // {...field}
                            // {...props}
                            accept="application/pdf"
                            className={`invisible ${documentName === "medicalProviderBills" ? `fileInputStyle` : `input-control file-upload-control ${className ?? ''} ${disabledClass}`}`}
                            disabled={isDisabled}
                            onChange={handleChange}
                            id="filePicker"

                        />
                        <ErrorMessage form={form} field={field} />
                    </div>
                </label>
                :
                <>
                    <label> {label} </label>
                    <div>
                        <input
                            type="file"
                            ref={elementRef => fileUploadRef = elementRef}
                            multiple={multipleFileUpload}
                            // {...field}
                            {...props}
                            className={documentName === "medicalProviderBills" ? `fileInputStyle` : `input-control file-upload-control ${className ?? ''} ${disabledClass}`}
                            disabled={isDisabled}
                            onChange={handleChange}
                            id={documentName === "medicalProviderBills" ? `fileInputStyle` : ''}
                        />
                        <ErrorMessage form={form} field={field} />
                    </div>
                </>

            }

            {children}
            {fileErrorList.length?<FileUploadErrorModal fileErrorList={fileErrorList} setFileErrorList={setFileErrorList}/> :""}
        </React.Fragment>
    );
};
